import { Button, Flex, PhotosIcon, Typography } from '@iheartjane/reefer';

import styles from './wizardNoResults.module.css';

interface WizardNoResultsProps {
  onEditAnswers: () => void;
}

export function WizardNoResults({ onEditAnswers }: WizardNoResultsProps) {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap={16}
      justifyContent="center"
      p={24}
      height="100%"
    >
      <div className={styles['cardStack']}>
        <div className={styles['card']}>
          <Flex
            alignItems="center"
            justifyContent="center"
            height="100%"
            background="grays-ultralight"
            borderRadius="xs"
          >
            <div className={styles['icon']}>
              <PhotosIcon color="grays-light" size="lg" />
            </div>
          </Flex>
        </div>
      </div>
      <Typography variant="header-bold">No matches this time.</Typography>
      <Typography textAlign="center">
        Try broadening one choice to see more matches.
      </Typography>
      <Button
        variant="primary"
        label="Edit answers"
        onClick={onEditAnswers}
        mt={8}
      />
    </Flex>
  );
}
